import { IonItem, IonLabel, IonList } from "@ionic/react";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router";

import useCountersStore from "../../../../store/counts";
import useContactsStore from "../../../../store/contacts";

export default function MobileMessageStats({ isLoading }: { isLoading?: boolean }) {
  const history = useHistory();
  const { filters, setFilters } = useContactsStore((state) => ({ filters: state.filters, setFilters: state.setFilters }));
  const counters = useCountersStore((state) => ({
    review: state.escalated,
    manual: state.manualUnread,
    total: state.total,
    loading: state.loading,
  }));
  const { review, manual, total, loading } = counters;

  const isRequesting = isLoading || loading;

  const onBeforeNavigate = () => {
    const updated = filters.map(item =>
      item.type === "bucket" ? { ...item, isActive: true, value: "pending" } : item
    );
    setFilters(updated);
    history.push("/chats?bucket=pending")
  }

  if (total === 0 && !isRequesting) return null;

  return (
    <>
      <div className="view-pane">
        <div className="fw-semibold">
          <span className="mr-1">
            <FormattedMessage id="home.requiresAction" />{": "}
            <span className="fw-bold color-visito-1">
              {Intl.NumberFormat("en-US").format(total)}
            </span>
          </span>
        </div>
      </div>
      <IonList inset={true}>
        {review > 0 && (
          <IonItem>
            <IonLabel>
              <FormattedMessage id="home.messagesUnderReview" />
            </IonLabel>
            <div slot="end">
              <span className="badge rounded-pill text-bg-warning me-2 total-badge">
                {review}
              </span>
            </div>
          </IonItem>
        )}
        {manual > 0 && (
          <IonItem lines="none">
            <IonLabel>
              <FormattedMessage id="home.unreadManualMessages" />
            </IonLabel>
            <div slot="end">
              <span className="badge rounded-pill text-bg-info me-2 total-badge">
                {manual}
              </span>
            </div>
          </IonItem>
        )}
        <IonItem
          button
          onClick={onBeforeNavigate}
          disabled={isRequesting}
          lines="none"
          detail={false}
        >
          <IonLabel className="mr-0">
            <span
              className="btn btn-visito-primary w-100 d-flex align-items-center justify-content-center gap-2"
            >
              <FormattedMessage id="common.reviewNow" />
            </span>
          </IonLabel>
        </IonItem>
      </IonList>
    </>
  );
}
